import * as landscapeImages from "../images/landscape";
import * as priorityImages from "../images/priority";

const hostURL = "https://crpmenu.gri.msstate.edu/";

// const hostURL = 'http://localhost:8080/';

export default hostURL;

export const allCoverTypes = [
  {
    src: landscapeImages.aquaculture,
    alt: "aquaculture",
    label: "Aquaculture Ponds",
    value: "aquaculture",
    qContent: "Land used for commercial pond-raised aquaculture.",
  },
  {
    src: landscapeImages.cropland,
    alt: "Cropland",
    label: "Cropland",
    value: "cropland",
    qContent:
      "Area used for the production of crops for harvest, either cultivated or non-cultivated.",
  },
  // {
  //   src: timber,
  //   alt: "timber",
  //   label: "Timber",
  //   value: "timber",
  // },
  {
    src: landscapeImages.pasture,
    alt: "pasture",
    label: "Pasture",
    value: "pasture",
    qContent:
      "Grazing lands comprised of either introduced or native forage species.",
  },
  {
    src: landscapeImages.wetland,
    alt: "wetland",
    label: "Wetland",
    value: "wetland",
    qContent:
      "Includes areas with generally wet soils that may flood for all- or part of the year.",
  },
];

export const allPriorities = [
  {
    src: priorityImages.winderosion,
    alt: "winderosion",
    label: "Wind Erosion",
    value: "winderosion",
    qContent:
      "Wind erosion causes damage to land by transporting soil, which can cause soil loss, dryness, and soil deterioration.",
  },
  {
    src: priorityImages.watererosion,
    alt: "watererosion",
    label: "Water Erosion",
    value: "watererosion",
    qContent:
      "Erosion of soil by running water through fields or along stream banks.",
  },
  {
    src: priorityImages.soilhealth,
    alt: "soilhealth",
    label: "Soil Health",
    value: "soilhealth",
    qContent:
      "Water quality concerns may result from compaction, organic matter depletion, excess salts and chemicals nutrients, and/or aggregate instability.",
  },
  {
    src: priorityImages.excesswind,
    alt: "excesswind",
    label: "Excess Wind",
    value: "excesswind",
    qContent:
      "Wind can lead to problems with soil erosion, snowdrift, and inefficient energy use.",
  },
  {
    src: priorityImages.drought,
    alt: "drought",
    label: "Drought",
    value: "drought",
    qContent:
      "Lack of water can be caused by weather patterns, water depletion, and inefficient use of irrigation water.",
  },
  // {
  //   src: priorityImages.watertemperature,
  //   alt: "watertemperature",
  //   label: "Water Temperature",
  //   value: "elevatedwatertemperature",
  //   qContent: "High surface water temperatures can cause problems for aquatic life and water quality.",
  // },
  {
    src: priorityImages.flooding,
    alt: "flooding",
    label: "Flooding",
    value: "flooding",
    qContent:
      "Ponding, flooding, and other drainage issues caused by excess water in soil.",
  },
  {
    src: priorityImages.snowdrift,
    alt: "snowdrift",
    label: "Snow Drift",
    value: "snowdrift",
    qContent:
      "Drifted snow that can prohibit humans and animals from accessing structures or features.",
  },
  {
    src: priorityImages.waterquality,
    alt: "waterquality",
    label: "Water Quality",
    value: "waterquality",
    qContent:
      "Water quality concerns may result from excess nutrients, pathogens, chemicals, pesticides, and/or pollutants in water supply.",
  },
  {
    src: priorityImages.aquatic,
    alt: "aquatic",
    label: "Aquatic",
    value: "aquatic",
    qContent: "Fish and other aquatic wildlife.",
  },
  {
    src: priorityImages.biggame,
    alt: "biggame",
    label: "Big Game",
    value: "biggame",
    qContent: "Deer, elk, pigs, bears, and other wildlife hunted for sport.",
  },
  {
    src: priorityImages.grasslandbirds,
    alt: "grasslandbirds",
    label: "Grassland Birds",
    value: "grasslandbirds",
    qContent:
      "Birds, such as quail and pheasant, that require grassland cover.",
  },
  {
    src: priorityImages.forestbirds,
    alt: "forestbirds",
    label: "Forest Wildlife",
    value: "forestbirds",
    qContent: "Wildlife, such as turkey, that require forest cover.",
  },

  {
    src: priorityImages.pollinators,
    alt: "pollinators",
    label: "Pollinators",
    value: "pollinators",
    qContent:
      "Pollinators include honeybees, butterflies, birds, bats and other animals.",
  },
  {
    src: priorityImages.waterfowl,
    alt: "waterfowl",
    label: "Waterfowl",
    value: "waterfowl",
    qContent: "Ducks, geese, and swans that require water or wetland cover.",
  },
  {
    src: priorityImages.carbonstorage,
    alt: "carbonstorage",
    label: "Carbon Storage",
    value: "carbonstorage",
    qContent:
      "Storage and sequestration of carbon dioxide from the atmosphere.",
  },
  {
    src: priorityImages.priorityecosystem,
    alt: "priorityecosystem",
    label: "Ecosystem",
    value: "priorityecosystem",
    qContent:
      "Protecting and restoring ecosystems for environmental and wildlife benefits.",
  },
];

export const allLabels = [...allCoverTypes, ...allPriorities].reduce(
  (acc, { value, label }) => {
    acc[value] = label;
    return acc;
  },
  {}
);
